import React, { useContext, useState } from 'react';
import forgeticon from '../../../Assets/Images/catchforgetIcon.png'
import { FormNewPassword, LangContext } from '../../../App'
import String from '../../../Assets/Localization/Local'
import { Modal, Col, Row } from 'react-bootstrap'
import './ForgetPassword.css'
import { useForm } from "react-hook-form";
import { API_ENDPOINT } from '../../../AppConfig';
import axios from 'axios';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies'
import * as yup from "yup";
import string from '../../../Assets/Localization/Local'

const NewPassword = (props) => {

    const { lang } = useContext(LangContext)
    const { openFormNewPass, ToggleForm_newPass } = useContext(FormNewPassword)
    const [show, setShow] = useState(true);
    const [Field1Type, setField1Type] = useState('password');
    const [Field2Type, setField2Type] = useState('password');
    

    const onSubmit = (data) => {
        let uri = `${API_ENDPOINT}/phonePasswordChange`
        let submitData = {}
        submitData.phone = props.phone.phone
        submitData.password = data.password
        // console.log('submit data=> ', submitData)
        axios.put(uri, submitData, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            // console.log('send new pass done=> ', response.data)
            cookie.save("CatchItUser", response.data.user, { path: '/' })
            // cookie.save("HB_token", response.data.token, { path: '/' })
            ToggleForm_newPass()
        }).catch(error => {
            // console.log('send new pass error=> ', error.response)
        })
    }

    const handleField1Type = (e) => {
        // console.log('eeee=> ', e.target.type)
        if (Field1Type === 'password') {
            setField1Type('text')
        }
        else {
            setField1Type('password')
        }
    }
    const handleField2Type = (e) => {
        // console.log('eeee=> ', e.target.type)
        if (Field2Type === 'password') {
            setField2Type('text')
        }
        else {
            setField2Type('password')
        }
    }
    let Validation = yup.object().shape({
        password: yup.string().required({ ar: "يجب ادخال كلمة المرور *", en: 'Password is required' }),
        confirmPassword: yup.string().required({ ar: "يجب ادخال كلمة المرور *", en: 'Password is required' })
            .test('passwords-match', { ar: 'كلمتا المرور لا يتطبقان', en: "Two Passowrds don't match" }, function (value) {
                return this.parent.password === value;
            }),

    })
    const { register, handleSubmit, errors, control, watch, reset, setValue, getValues, clearError, setError } = useForm({
        validationSchema: Validation
    });
    string.setLanguage(lang)
    return (
        <div>
            <Modal className="forgetmodal" show={show} onHide={props.close} animation={false}>
                <Modal.Header className="justify-content-center pb-0">
                    <h3 className="mt-3">{string.enternewpassword}</h3>
                    <i style={{ left: "10px" }} onClick={props.close} className="fas fa-times close-icon"></i>
                </Modal.Header>
                <Modal.Body>
                    <div className="imgforgetcontainer">
                        <img src={forgeticon} alt="deleteimg" className="forgetimg" />
                    </div>
                    <h5></h5>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }}>
                        <Row>
                            <Col lg='12' style={{ marginBottom: '30px' }}>
                                <div style={{ marginBottom: '28px', position: 'relative' }}  >
                                    <label style={{ textAlign: lang === "ar" ? "right" : "left" }} className="forget-label"> {string.password}</label>
                                    <input style={{ textAlign: lang === "ar" ? "right" : "left" }} type={Field1Type} name="password" ref={register}
                                        placeholder=""
                                        className="forget-input" />
                                    <Link
                                        onClick={handleField1Type}
                                        className="TextFieldIconLink"
                                        style={{ left: '1.5rem', background: 'transparent', border: 'none', padding: '0px', outline: 'none' }}>
                                    </Link>

                                </div>
                                {errors["password"] && <p className="ErrorStyle px-3">{errors["password"]["message"]}</p>}

                                <div className="textWithIcon"  >
                                    <label style={{textAlign: lang==="ar"?"right":"left"}} className="forget-label">{string.confpassword}</label>
                                    <input style={{textAlign: lang==="ar"?"right":"left"}} type={Field2Type} name="confirmPassword" ref={register}
                                        placeholder=" "
                                        className="forget-input" />
                                    <Link
                                        onClick={handleField2Type}
                                        className="TextFieldIconLink"
                                        style={{ left: '1.5rem', background: 'transparent', border: 'none', padding: '0px', outline: 'none' }}>
                                    </Link>

                                </div>
                                {errors["confirmPassword"] && <p className="ErrorStyle px-3">{errors["confirmPassword"]["message"]}</p>}

                            </Col>
                        </Row>
                        <button className="btn nextBTN btn-block mb-4" type="submit">{string.saveBTN}</button>
                    </form>
                </Modal.Body>
            </Modal>
        </div >
    );
}

export default NewPassword;

